/**
 * created by SunChenyao on 2020/12/11
 */
import React from 'react';
import ReactDOM from 'react-dom';
import { InfiniteScroll, PullToRefresh } from 'antd-mobile';
import { sleep } from 'antd-mobile/es/utils/sleep';
import {
    NewsDetailWrapper,
    NewsImgWrap,
    NewsThreeImgWrap,
    NewsItem,
    NewsItemOther,
    NewsTitle,
    NewsTitleNoImg,
    NewsTitleOneImg,
    NewsPubs,
    VideoImg,
    VideoIcon
} from '../../../common/generalStyle';
import {
    NavBar,
    ReturnButton,
    SearchIcon
} from './ContentStyle';

import Label from "./Label";
import httpAxios from "../../../http/httpAxios";
import api from "../../../http/api";
import {
    startMinsTime
} from '../../../utils/utils';
import {
    isBlocked,
    getStamp
} from '../../../utils/localBlock';
const playSvg = require('../../../images/plays.svg');
const returnButton = require('../../../images/return_button.svg')
const searchButton = require('../../../images/search_button.svg')
const listVipLogo = require('../../../images/listVipLogo.png');

const NUM_ROWS = 10;
let pageIndex = 1;

function genData(pIndex = 0) {
    const dataArr = [];
    for (let i = 0; i < NUM_ROWS; i++) {
        dataArr.push(`row - ${(pIndex * NUM_ROWS) + i}`);
    }
    return dataArr;
}

class Content extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            userPID: '',
            refreshing: false,
            isLoading: true,
            height: document.documentElement.clientHeight,

            data: [],
            comTypes: [],
            typeKeys: {},
            readType: '2',
            listType: '10',
            targetID: '0',
            hasMore: true,
            rowCount: 0,

            // liveID: 1,
            // livedata: [],
        };
    }

    componentDidUpdate() {
        document.body.style.overflow = 'auto';
    }

    componentDidMount() {
        var that = this;
        window.userInfo = function (data, params) {
            const prevUserPID = that.state.userPID;
            that.setState({
                userPID: data.UserPID
            }, () => {
                // 登录态注入后重拉第一页，带上 userID 让后端按黑名单过滤（谁拉黑的谁不可见）
                if (!prevUserPID && data.UserPID) {
                    pageIndex = 1;
                    that.state.refreshing = true;
                    that.getList(that.state.targetID, that.state.readType, that.state.listType).then(() => {
                        that.state.refreshing = false;
                        that.setState({ isLoading: false });
                    });
                }
            });
        }

        // this.getLiveData();
        pageIndex = 0;
        this.getComType();
        // this.getList(null, null, null);


        setTimeout(() => {
            this.setState({
                refreshing: false,
                isLoading: false,
            });
        }, 1500);

        // —— 本地黑名单兜底：webview 从详情页返回后，把本地黑名单中的条目过滤掉 ——
        this._lastStamp = getStamp();
        this._refilterLocalBlock();
        // 1) 回到前台立即过滤（focus / pageshow / visibilitychange）
        this._onFocus = this._refilterLocalBlock;
        this._onVisibility = () => {
            if (document.visibilityState === 'visible') this._refilterLocalBlock();
        };
        window.addEventListener('focus', this._onFocus);
        window.addEventListener('pageshow', this._onFocus);
        document.addEventListener('visibilitychange', this._onVisibility);
        // 2) 兜底定时器：iOS WKWebView 可能不触发可见性事件，定时轮询本地黑名单时间戳，
        //    变化时仅对当前 state.data 重新过滤（不重新请求，开销极小）
        this._blockTimer = setInterval(this._refilterLocalBlock, 1500);
    }

    // 本地兜底过滤：从数组中剔除命中黑名单的文章 / 作者
    _filterLocalBlock = (list = []) => list.filter(obj => !isBlocked({
        articleID: obj.ID,
        authorName: obj.Author
    }));

    // 本地黑名单有更新时，对当前已加载列表重新过滤（不重新请求）
    _refilterLocalBlock = () => {
        const cur = getStamp();
        if (cur === this._lastStamp) return;
        this._lastStamp = cur;
        this.setState({
            data: this.state.data.filter(obj => !isBlocked({
                articleID: obj.ID,
                authorName: obj.Author
            }))
        });
    };

    componentWillUnmount() {
        window.removeEventListener('focus', this._onFocus);
        window.removeEventListener('pageshow', this._onFocus);
        document.removeEventListener('visibilitychange', this._onVisibility);
        if (this._blockTimer) clearInterval(this._blockTimer);
    }

    // getLiveData = async () => {
    //     const res = await httpAxios(api.getLiveUrl, {
    //         liveID: this.state.liveID
    //     });
    //     if (res) {
    //         this.setState({
    //             livedata: res.Data,
    //         })
    //     }
    // }

    goBackPage = () => {
        if (this.props.location?.search === '?v=1') {
            window.ReactNativeWebView.postMessage(JSON.stringify({ type: "goHome" }));
        } else {
            window.ReactNativeWebView.postMessage(JSON.stringify({ type: "goBack" }));
        }
    }

    getListRefresh = async (targetID, readType, listType) => {
        window.scrollTo(0, 0);
        this.state.refreshing = true;
        pageIndex = 1;
        await this.getList(targetID, readType, listType);
        this.state.refreshing = false;
        this.setState({
            isLoading: false,
        });
    }

    getList = async (targetID, readType, listType) => {
        if (!readType) readType = this.state.readType;
        if (!listType) listType = this.state.listType;
        if (!targetID) targetID = this.state.targetID;
        let params;
        if (targetID === '0') {
            params = {
                "pageSize": NUM_ROWS,
                "pageIndex": pageIndex,
                "ReadType": readType,
                "ListType": listType
            }
        } else {
            params = {
                "targetID": targetID,
                "pageSize": NUM_ROWS,
                "pageIndex": pageIndex,
                "ReadType": readType,
                "ListType": listType
            }
        }

        // 带上当前登录用户ID，后端按黑名单过滤（谁拉黑的谁不可见）。未登录则不传该字段，后端 Guid? 为 null 不过滤。
        if (this.state.userPID) {
            params.userID = this.state.userPID;
        }

        const res = await httpAxios(api.getComList, params);
        if (res) {
            const str = res.Message.split(':')[1];
            const count = Number(str.slice(0, str.length - 1));
            this.state.rowCount = count;
            if (res.Data.length > 0) {
                // 本地兜底过滤：隐藏本地黑名单中的文章 / 作者
                const list = this._filterLocalBlock(res.Data);
                if (this.state.refreshing) {
                    this.setState({
                        data: list,
                        targetID,
                        readType,
                        listType
                    })
                }
                else {
                    let tempData = [...this.state.data, ...list];

                    this.setState({
                        data: tempData,
                        targetID,
                        readType,
                        listType
                    })
                }
            } else {
                this.setState({
                    data: [],
                    targetID,
                    readType,
                    listType
                })
                this.state.hasMore = false;
            }

            if (this.state.data.length == this.state.rowCount) {
                this.state.hasMore = false;
            }
            else {
                this.state.hasMore = true;
            }
        }
    }

    getComType = async () => {
        const res = await httpAxios(api.getComType);
        let typeKeys = {};
        if (res) {
            res.Data.map(i => {
                typeKeys[i.ID] = i.Title
            })
            this.setState({
                comTypes: res.Data,
                typeKeys: typeKeys
            })
        }
    }

    onRefresh = async () => {
        this.setState({ refreshing: true, isLoading: true });
        await this.getListRefresh(null, null, null);
        setTimeout(() => {
            this.setState({
                refreshing: false,
                isLoading: false,
            });
        }, 600);
    };

    onEndReached = async (event) => {
        if (!this.state.hasMore) {
            return;
        }
        pageIndex += 1;
        await this.getList(null, null, null);
        this.setState({ isLoading: true });
        setTimeout(() => {
            this.setState({
                isLoading: false,
            });
        }, 1000);
    };

    render() {
        const {
            data,
            comTypes,
        } = this.state;

        return (<div>
            <NavBar>
                <ReturnButton onClick={this.goBackPage}><img src={returnButton} alt="返回" /></ReturnButton>
                <span>社区</span>
                <SearchIcon onClick={() => { window.ReactNativeWebView.postMessage(JSON.stringify({ type: "searchnav", weburl: "/search" })) }}><img src={searchButton} alt="搜索" /></SearchIcon>
                <Label cb={this.getListRefresh} list={comTypes} />
            </NavBar>
            <div style={{ height: '8.5rem' }}></div>
            <PullToRefresh
                onRefresh={async () => {
                    await sleep(1000)
                    await this.onRefresh();
                }}
            >
                {
                    data.map((obj, indexKey) => (
                        <div key={indexKey}>
                            <NewsDetailWrapper >
                                <a onClick={() => { window.ReactNativeWebView.postMessage(JSON.stringify({ type: "detailnav", title: obj.Author, weburl: '/community/communitydetail/' + obj.ID + '/community' + '?' + this.state.userPID, })); }}>
                                    {
                                        obj.ShowType == 3 ?
                                            <NewsItemOther div key={obj.ID} >
                                                <NewsTitle>{obj.Title}</NewsTitle>
                                                <VideoImg>
                                                    {/* {
                                                obj.ListIMG === null ? <img src={
                                                    obj.ImageAppUrl.split(';')[0]
                                                } alt="" /> : <img src={obj.ListIMG} alt="" />
                                            } */}
                                                    {
                                                        obj.ListIMG === null ? obj.ImageAppUrl.split(';')[0].indexOf('?') > 0 ? <img src={obj.ImageAppUrl.split(';')[0].slice(0, obj.ImageAppUrl.split(';')[0].indexOf('?')) + '?x-oss-process=image/resize,w_690,m_lfit'} alt="" />
                                                            : <img src={obj.ImageAppUrl.split(';')[0] + '?x-oss-process=image/resize,w_690,m_lfit'} alt="" />
                                                            : obj.ListIMG.indexOf('?') > 0 ? <img src={obj.ListIMG.slice(0, obj.ListIMG.indexOf('?')) + '?x-oss-process=image/resize,w_690,m_lfit'} alt="" />
                                                                : <img src={obj.ListIMG + '?x-oss-process=image/resize,w_690,m_lfit'} alt="" />
                                                    }
                                                    <VideoIcon>
                                                        <img src={playSvg} alt="" />
                                                    </VideoIcon>
                                                </VideoImg>
                                            </NewsItemOther >
                                            :
                                            <>
                                                {
                                                    obj.ShowType == 0 ?
                                                        <NewsItem div key={obj.ID} >
                                                            {obj.ListIMG != null ? <>
                                                                <NewsTitleOneImg>{obj.Title}</NewsTitleOneImg>
                                                                <NewsImgWrap>
                                                                    {/* <img src={obj.ListIMG} alt="" /> */}
                                                                    {
                                                                        obj.ListIMG.indexOf('?') > 0 ? <img src={obj.ListIMG.slice(0, obj.ListIMG.indexOf('?')) + '?x-oss-process=image/resize,w_240,m_lfit'} alt="" />
                                                                            : <img src={obj.ListIMG + '?x-oss-process=image/resize,w_240,m_lfit'} alt="" />
                                                                    }
                                                                </NewsImgWrap>
                                                            </> : <NewsTitleNoImg>{obj.Title}</NewsTitleNoImg>
                                                            }
                                                        </NewsItem >
                                                        :
                                                        <>
                                                            {
                                                                obj.ShowType == 2 ?
                                                                    <NewsItemOther div key={obj.ID} >
                                                                        <NewsTitle>{obj.Title}</NewsTitle>
                                                                        <NewsThreeImgWrap>
                                                                            {
                                                                                obj.ImageAppUrl.split(';').map((image, index) => (
                                                                                    index < 3 && <div>
                                                                                        {/* <img src={image} alt="" /> */}
                                                                                        {
                                                                                            image.indexOf('?') > 0 ? <img src={image.slice(0, image.indexOf('?')) + '?x-oss-process=image/resize,w_226,m_lfit'} alt="" />
                                                                                                : <img src={image + '?x-oss-process=image/resize,w_226,m_lfit'} alt="" />
                                                                                        }
                                                                                    </div>
                                                                                ))
                                                                            }
                                                                        </NewsThreeImgWrap>
                                                                    </NewsItemOther >
                                                                    :
                                                                    <NewsItem div key={obj.ID} >
                                                                        <NewsTitleOneImg>{obj.Title}</NewsTitleOneImg>
                                                                        <NewsImgWrap>
                                                                            {/* {
                                                                        obj.ListIMG === null ? <img src={
                                                                            obj.ImageAppUrl.split(';')[0]
                                                                        } alt="" /> : <img src={obj.ListIMG} alt="" />
                                                                    } */}
                                                                            {
                                                                                obj.ListIMG === null ? obj.ImageAppUrl.split(';')[0].indexOf('?') > 0 ? <img src={obj.ImageAppUrl.split(';')[0].slice(0, obj.ImageAppUrl.split(';')[0].indexOf('?')) + '?x-oss-process=image/resize,w_690,m_lfit'} alt="" />
                                                                                    : <img src={obj.ImageAppUrl.split(';')[0] + '?x-oss-process=image/resize,w_690,m_lfit'} alt="" />
                                                                                    : obj.ListIMG.indexOf('?') > 0 ? <img src={obj.ListIMG.slice(0, obj.ListIMG.indexOf('?')) + '?x-oss-process=image/resize,w_690,m_lfit'} alt="" />
                                                                                        : <img src={obj.ListIMG + '?x-oss-process=image/resize,w_690,m_lfit'} alt="" />
                                                                            }
                                                                        </NewsImgWrap>
                                                                    </NewsItem >
                                                            }
                                                        </>
                                                }
                                            </>
                                    }
                                    <NewsPubs>
                                        {
                                            obj.IsBussUser && <div><img src={listVipLogo} alt="" /></div>
                                        }
                                        <img src={obj.HeadImg} alt="" /><span>{obj.Author}</span><span>{obj.ClickNum}浏览</span><span>{startMinsTime(obj.Addtime)}</span>
                                        {
                                            obj.IsTop && <p>置顶</p>
                                        }
                                    </NewsPubs>

                                </a>
                            </NewsDetailWrapper>
                        </div>
                    ))
                }
            </PullToRefresh>
            <InfiniteScroll loadMore={this.onEndReached} hasMore={this.state.hasMore} />
        </div>);
    }
}

export default Content